import React, { useEffect, useRef, useState } from "react";
import "./style.css";
import { getDealersAndDevices } from "../../APIs";
import { AllDevicesIcon, InStockIcon } from "../../Assets/images/svgs";
import PATHS from "../../Routes/paths";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SELLER_DES } from "../../Library/constants";

const DevicesOverview = ({ showIcons }) => {
  const [ dealerDevices, setDealerDevices ] = useState({});
  const navigate = useNavigate();
  const DESIGNATION = JSON.parse(window.localStorage.getItem("des"));
  const [ searchParams ] = useSearchParams();
  const dealerId = useRef(searchParams.get("idx"));

  useEffect(() => {
    getDealersAndDevices(dealerId.current || null, (err, data) => {
      if (err) console.error(err);
      else {
        if (data && data.length) {
          if (!data[0].stock) data[0].stock = 0;
          if (!data[0].installed) data[0].installed = 0;

          data[0].total = data[0].stock + data[0].installed;
        }

        setDealerDevices(data[0])
      };
    })
  }, []);

  const overviewLablesAndKeys = [
    { label: "In Stock", key: "stock", icon: <InStockIcon className="devices-overview-icon" />, seperator: true, query: `inStock=true` },
    { label: "Installed Devices", key: "installed", icon: <AllDevicesIcon className="devices-overview-icon" />, query: `installed=true` },
    { label: "All Devices", key: "total", icon: <AllDevicesIcon className="devices-overview-icon" />, seperator: true, query: `inStock=true&installed=true` },
  ];

  const handleNavigation = (query) => {
    if (query) {
      if (DESIGNATION === SELLER_DES) {
        navigate(`${PATHS.SHOW_DEALERS}/${PATHS.DEVICES}?idx=${dealerId.current}&${query}`);
      } else {
        navigate(`${PATHS.INVENTORY_OVERVIEW}/${PATHS.DEVICES}?${query}`);
      }
    }
  }

  return (
    <div className="widget-group devices-overview">
      <div className="devices-overview-widget">
        { overviewLablesAndKeys.map((detail, idx) => (
          <React.Fragment key={idx}>
            <div className="device-count-container">
              <p className="device-count-label">{detail.label}</p>
              <p className={`device-count-value ${detail.query ? "show-pointer" : ""}`} onClick={() => handleNavigation(detail.query)} >{(dealerDevices && dealerDevices[detail.key]) ? dealerDevices[detail.key] : 0}</p>
            </div>
            {/* {detail.seperator && <div className="device-counts-seperator"></div>} */}
          </React.Fragment>
        )) }
      </div>
    </div>
  )
}

export default DevicesOverview
